import React from 'react';
import LegalPage from '@/components/LegalPage';

const PrivacyPolicy = () => (
  <LegalPage
    title="Privacy Policy"
    effectiveDate="September 9, 2025"
    intro="At Rajasthan Trading Co. (operating under the brand name Raretto), your privacy is very important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit or make a purchase on our website."
    sections={[
      {
        heading: '1. Information We Collect',
        paragraphs: ['We may collect the following types of information:'],
        list: [
          'Personal Information: Name, email address, phone number, billing and shipping address.',
          'Payment Information: Processed securely via our payment partners (we do not store card details).',
          'Usage Data: Information about how you use our website (cookies, IP address, browser type, device details).',
        ],
      },
      {
        heading: '2. How We Use Your Information',
        paragraphs: ['We use your information to:'],
        list: [
          'Process and deliver your orders.',
          'Communicate order updates, offers, or promotions (only if you opt in).',
          'Improve our website, products, and services.',
          'Comply with legal obligations.',
        ],
      },
      {
        heading: '3. Sharing Your Information',
        paragraphs: ['We do not sell or rent your personal information. We may share data only with:'],
        list: [
          'Trusted service providers (payment gateways, delivery partners, website hosting).',
          'Legal authorities, if required by law.',
        ],
      },
      {
        heading: '4. Cookies',
        paragraphs: [
          'Our website uses cookies to enhance your browsing experience, analyze site traffic, and personalize content. You may disable cookies through your browser settings, but some features may not work properly.',
        ],
      },
      {
        heading: '5. Data Security',
        paragraphs: [
          'We take reasonable technical and organizational measures to protect your personal data from unauthorized access, misuse, or disclosure.',
        ],
      },
      {
        heading: '6. Your Rights',
        paragraphs: ['You have the right to:'],
        list: [
          'Access, update, or delete your personal data.',
          'Opt out of marketing communications at any time.',
          'Request information about how your data is processed.',
        ],
      },
      {
        heading: '7. Changes to This Policy',
        paragraphs: [
          'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date.',
        ],
      },
      {
        heading: '8. Contact Us',
        paragraphs: ['If you have any questions or concerns regarding this Privacy Policy, please contact us at:'],
        list: [
          'Rajasthan Trading Co. (Brand: Raretto), Worli, Mumbai, Maharashtra 400018',
          'Email: customersupport@raretto.com',
          'Phone: +91 91677 98999',
        ],
      },
    ]}
  />
);

export default PrivacyPolicy;
